import { useRouteLoaderData } from 'react-router';
import { paths } from '../../common/constants/pathVariables.js';
import { orderRequestsMsg, ordersMsg, t } from '../../common/i18n/index.js';
import { hasSubscriptionActionsPendingForApproval } from '../../common/utils/employeeUtils.js';
import { HeroHeading, HeroHeadingType } from '../HeroHeading/index.js';
import { LocalNavi } from '../LocalNavi/index.js';
import type { SubscriptionActionsResponse } from '../../generated/api/models.js';

export const EoeOrdersBreadcrumb = () => {
  return (
    <HeroHeading
      heroHeadingType={HeroHeadingType.EMPLOYEE_ORDERS}
      title={t.Y29L(orderRequestsMsg)}
      fullScreen={true}
      center={true}
    />
  );
};

export const EoeOrdersNavi = () => {
  const { searchResults } = useRouteLoaderData('eoe-pending-orders') as SubscriptionActionsResponse;

  return (
    <LocalNavi
      categories={[
        {
          children: t.I9C0(ordersMsg),
          to: paths.EMPLOYEE_PENDING_REVIEW_ORDERS,
        },
        {
          children: t.Z1M1('Redeem requests'),
          to: paths.EMPLOYEE_CHANGE_REQUEST_ORDERS,
          hint: hasSubscriptionActionsPendingForApproval(searchResults),
        },
        {
          children: t.B2B9('Archive'),
          to: paths.EMPLOYEE_FINISHED_REVIEW_ORDERS,
        },
      ]}
    />
  );
};
